export default __webpack_public_path__ + "static/media/doubleeagle8.17bc84ca.jpg";